export default "__VITE_ASSET__CrGLCDd6__"